import React from 'react';
import { useTheme } from '../../../../theme';
import cn from 'classnames';
export var CategoryBadge = function (props) {
    var _a;
    var css = useTheme('Communications').CategoryBadge;
    return React.createElement("span", { className: cn(css.badge, (_a = {}, _a[css.badge_active] = props.active, _a)) }, props.value);
};
